import {mapGetters} from "vuex";
import {computePosition} from "../package/scaleMath";
import {fiveYearGain} from "@/utils/pd";

/**
 * Mixin: the student's place on their district's salary schedule, from the
 * career profile already on file (district, degree, column, years — the
 * `salary` block of the PD summary / dashboard feed) and the published
 * schedule cached in the pd store module.
 *
 * Hosts get `salary`, `scale` (undefined while loading, null when none is
 * published), `scaleLoading`, `position`, `targets`, `firstTarget`.
 */
export default {
    computed: {
        ...mapGetters(['pdSummary', 'dashboardPd', 'payScaleFor']),
        salary() {
            const source = this.pdSummary || this.dashboardPd;
            return (source && source.salary) || {ready: false};
        },
        scale() {
            if (!this.salary.ready || !this.salary.district_id) return null;
            return this.payScaleFor(this.salary.district_id);
        },
        scaleLoading() {
            return this.salary.ready && !!this.salary.district_id && this.scale === undefined;
        },
        position() {
            if (!this.scale || !this.salary.ready) return null;
            return computePosition(this.scale, this.salary.highest_degree, this.salary.hours_column, this.salary.years_teaching);
        },
        targets() {
            return (this.position && this.position.targets) || [];
        },
        firstTarget() {
            return this.targets.length ? this.targets[0] : null;
        },
        firstTargetFiveYear() {
            return fiveYearGain(this.position, this.firstTarget);
        },
    },
    methods: {
        loadScale() {
            if (this.salary.ready && this.salary.district_id) {
                this.$store.dispatch('getPayScale', this.salary.district_id).catch(() => {});
            }
        }
    },
    watch: {
        'salary.district_id'() {
            this.loadScale();
        },
        'salary.ready'() {
            this.loadScale();
        }
    },
    mounted() {
        this.loadScale();
    }
};
